/** @format */

import React from "react";
import { Modal, ModalBody } from "react-bootstrap";
import { IMAGES } from "../../constants/constants";
import { goToAppOrStore } from "../../helper/helper";

export default function DownloadAppModal(props) {
  const { postId, postOwner, show, onClose, invitationId } = props;

  // Single OneLink covers both cases natively, no client-side detection needed:
  // - app already installed -> OneLink's landing page opens it directly to the post
  // - app not installed -> sent to the correct store, then deferred-deep-links to
  //   the post on first open (Android via Play Install Referrer; iOS via AppsFlyer
  //   attribution matching).
  // Replaces the old Firebase Dynamic Links (getpaths.page.link) smart link, which
  // is permanently gone (Google shut down Dynamic Links Aug 2025), and the ad-hoc
  // paths:// / intent:// probe that used to run here disconnected from this button.
  // Shared with DownloadAppBanner so both send users through the identical flow.
  const redirectOnAppStore = () => goToAppOrStore(postId, invitationId);

  return (
    <div className="signin-modal">
      <Modal
        backdropClassName="dialog-invitation"
        centered
        show={!!show}
        dialogClassName="modal-90w custom-dialog"
        onHide={onClose}
        size="lg"
        backdrop="static"
      >
        <ModalBody style={{ padding: 0 }}>
          <div style={{
            position: "relative",
            padding: "28px 24px 24px",
            textAlign: "center",
            borderRadius: 12,
            overflow: "hidden",
          }}>
            {/* Close button */}
            <button
              onClick={onClose}
              aria-label="Close"
              style={{
                position: "absolute",
                top: 12,
                right: 12,
                background: "#f26739",
                border: "none",
                borderRadius: "50%",
                width: 30,
                height: 30,
                color: "white",
                cursor: "pointer",
                fontSize: 20,
                lineHeight: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
              }}
            >
              &times;
            </button>

            {/* Paths logo */}
            <img
              alt="Paths logo"
              src={IMAGES.NEW_PATHS_LOGO.default}
              style={{ width: 130, marginBottom: 20 }}
            />

            {/* Orange invite banner */}
            {postOwner && postOwner.name && (
              <div style={{
                background: "#f26739",
                borderRadius: 10,
                padding: "14px 16px",
                marginBottom: 16,
              }}>
                <p style={{
                  color: "white",
                  fontWeight: 700,
                  margin: 0,
                  fontSize: 18,
                  fontFamily: "Outfit-Bold",
                }}>
                  {postOwner.name}
                </p>
                <p style={{
                  color: "white",
                  margin: 0,
                  fontSize: 14,
                  fontFamily: "Outfit-Regular",
                }}>
                  Wants to collaborate with you on Paths!
                </p>
              </div>
            )}

            {/* Body text */}
            <p style={{
              color: "#333",
              fontSize: 15,
              marginBottom: 24,
              fontFamily: "Outfit-Regular",
            }}>
              Want to collaborate? Download the app to continue.
            </p>

            {/* CTA button */}
            <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
              <button
                onClick={redirectOnAppStore}
                style={{
                  background: "#f26739",
                  color: "white",
                  border: "none",
                  borderRadius: 24,
                  padding: "10px 24px",
                  cursor: "pointer",
                  fontWeight: 600,
                  fontSize: 15,
                  fontFamily: "Outfit-SemiBold",
                }}
              >
                Download App
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}
